module.exports = __webpack_public_path__ + "static/img/BranchCompany1.e4ed27ce.png";